"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JOURNEY_TYPE = exports.DEFAULT_SHIMMER_JOURNEY = void 0;
var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));
var JOURNEY_TYPE = {
  ROUND_TRIP: 2,
  ONE_WAY: 1
};
exports.JOURNEY_TYPE = JOURNEY_TYPE;
var DEFAULT_SHIMMER_JOURNEY = {
  JOURNEY_TYPE: JOURNEY_TYPE.ROUND_TRIP,
  BORDER_RADIUS: _theme.default.borderRadius.medium,
  HEIGHT: _theme.default.space.tiny
};
exports.DEFAULT_SHIMMER_JOURNEY = DEFAULT_SHIMMER_JOURNEY;